import {AxiosError} from 'axios';
import {axiosBffFetch} from '../../axios/axiosBffFetch';
import {getEnv} from '../../common/env/env';
import {setKakaoAccessToken} from '../../common/shared/login-pageweb/setKakaoAccessToken.function';

export async function postRefreshToken() {
  const response = await axiosBffFetch('/api/refresh_token', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    withCredentials: true,
    timeout: 5000,
  }).catch(e => {
    if ('isAxiosError' in e) {
      const axiosError = <AxiosError>e;
      if (axiosError.response && axiosError?.response?.status === 401) {
        setKakaoAccessToken(getEnv().useSandboxKakao, null);
      }
    }
  });
  if (!response) {
    return;
  }
  const accessToken = response.data.access_token;
  setKakaoAccessToken(getEnv().useSandboxKakao, accessToken);
}
